import React from 'react'

import { AboutUsContainer, AboutUsTitle } from './styles'

import US1 from '../../assets/images/us1.svg'
import US2 from '../../assets/images/US2.png'
import US3 from '../../assets/images/US3.png'
import { CardsContainer } from '../../components/CardContainer/styles'
import AboutUsCard from '../../components/AboutUsCard/index.jsx'

const AboutUs = () => {
	return (
		<AboutUsContainer id={"aboutus"}>
			<AboutUsTitle>Sobre nosotros</AboutUsTitle>
			<CardsContainer>
				<AboutUsCard image={US1} title='Productos de calidad' description='Trabajamos con marcas de primer nivel como GELFORM, MASSUAR y BODY CARE ' />
				<AboutUsCard image={US2} title='Acompañamiento' description='Estaremos a tu lado en todo momento durante tu recuperación' />
				<AboutUsCard image={US3} title='Profesionalismo' description='Brindamos asesoramiento profesional, somos especialistas.' />
			</CardsContainer>
		</AboutUsContainer>
	)
}

export default AboutUs
